module.exports = __webpack_public_path__ + "img/syllabus-level2.b29ed5c6.png";